document.querySelectorAll('.toggle__title').forEach(function(title) {
    title.addEventListener('click', function() {
        document.querySelectorAll('.toggle__text').forEach(function(text) {
            if (window.getComputedStyle(text).display === 'none') {
                text.style.display = 'block';
            } else {
                text.style.display = 'none';
            }
        });
        this.classList.toggle('toggled');
    });
});
